import React, { useContext } from 'react';
import { BrowserRouter, Route, Switch, Link, NavLink, Redirect } from 'react-router-dom';
import App from './App'
import Home from './home'
import User_manual from './User_manual'
import User_manual_he from './User_manual_he'
import terms_of_use from './terms_of_use'
import uploader from './uploader'
import details_receiver from './details_receiver'
import Developer_API from './Developer_API'
import Developer_API_he from './Developer_API_he'
import NotFoundPage from './404'


const AppRouter = () => {
    
    
  return(
  <BrowserRouter>
    <div>
    {/* <Switch>
    
    <Route component={Header} />
      </Switch> */}


      <Switch>
        <Route path="/" component={Home} exact={true} />
        <Route path="/get-credit-card-details/:dugoly_uid/:client_id/:amount/:business_name/:logo_id" component={App} />
        <Route path="/user-manual" component={User_manual} />
        <Route path="/user-manual-he" component={User_manual_he} />
        <Route path="/terms-of-use" component={terms_of_use} />
        <Route path="/uploader" component={uploader} />
        <Route path="/details-receiver" component={details_receiver} />
        <Route path="/Developer-API" component={Developer_API} />
        <Route path="/Developer-API-he" component={Developer_API_he} />
       
        {/* <Route path="/Thanks" component={Thanks}/> */}
       


{/* <Route path='/development-payment' component={() => { 
     window.location.href = 'https://meshulam.co.il/quick_payment?b=59102b00d1adf1711519131a93f2ed43'; 
     return null;
}}/> */}

{/* <Route path="/Appendices/Values/:wordKey" component={AppendicesGeneral}/> */}



{/* 404 */}
         <Route component={NotFoundPage} />
      </Switch>
    </div>
  </BrowserRouter>
);
}
export default AppRouter;



// WEBPACK FOOTER //
// ./src/AppRouter.js